import React from 'react';
import Stack from '@mui/material/Stack';
import { NavLink } from '../../NavLink';
import Typography from '@mui/material/Typography';
import { useLocalization } from '@im/react-localization';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var year = new Date().getFullYear().toString();
export function CopyRight(props) {
  var _props$copyRightLinks = props.copyRightLinks,
    copyRightLinks = _props$copyRightLinks === void 0 ? [] : _props$copyRightLinks;
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  return /*#__PURE__*/_jsxs(RootGrid, {
    container: true,
    direction: "row",
    justifyContent: {
      md: 'end',
      sm: 'end',
      xs: 'end'
    },
    "data-element": "RootGrid",
    "data-component": "CopyRight",
    "data-source-file": "CopyRight.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      className: "responsive-font",
      sx: {
        marginRight: '5px'
      },
      width: {
        sm: 'auto',
        xs: '100%'
      },
      "data-element": "Typography",
      "data-source-file": "CopyRight.tsx",
      children: translate('Footer.Copyright', {
        year: year
      })
    }), copyRightLinks && copyRightLinks.map(function (link, index) {
      return /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        sx: {
          marginLeft: '5px'
        },
        children: [/*#__PURE__*/_jsx(NavLink, {
          className: "responsive-font",
          "data-name": link.trackingTag,
          "data-testid": link.title,
          linkTarget: link.openUrlInNewTab ? '_blank' : '_self',
          navItem: {
            key: link.title,
            label: link.title,
            onClick: link.onClick,
            route: link.route,
            url: link.url
          }
        }, link.title), index < (copyRightLinks == null ? void 0 : copyRightLinks.length) - 1 && /*#__PURE__*/_jsx(Typography, {
          className: "responsive-font",
          sx: {
            marginLeft: '5px',
            marginTop: '-1px'
          },
          children: '|'
        })]
      }, "copyright-link-".concat(index));
    })]
  });
}
var RootGrid = styled(Grid)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .responsive-font': {
      fontSize: 'min(0.75rem,14px)'
    },
    marginTop: '5px'
  };
});